import React, { useLayoutEffect } from "react";
import "../../scss/global.scss";
import "./home.scss";
import Gallery from "../../components/gallery/gallery";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useRef } from "react";

gsap.registerPlugin(ScrollTrigger);

const Home: React.FC = () => {
    const containerRef = useRef(null);
    const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);

    useLayoutEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    
    useLayoutEffect(() => {
        const containerWidth = document.documentElement.clientWidth;
        const startLeftPx = containerWidth * 0.25 + 25; 
        const endLeftPx = containerWidth * 0.5 - 120; 

        const ctx = gsap.context(() => {
            const tl = gsap.timeline();
            const tl2 = gsap.timeline();
            tl.fromTo(".mayfair", { opacity: 0 }, { opacity: 1, duration: 1 })
                .to(".line.one", {
                    height: "calc(50% + 90px)",
                    duration: 0.75,
                    ease: "linear",
                })
                .to(
                    ".line.two",
                    {
                        duration: 0.75,
                        ease: "linear",
                        height: "calc(50% + 115px)",
                    },
                    "<"
                )
                .to(
                    ".line.three",
                    {
                        height: "calc(50% + 140px)",
                        duration: 0.75,
                        ease: "linear",
                    },
                    "<"
                )
                .to(
                    ".upside.one",
                    {
                        height: "calc(50% + 140px)",
                        duration: 0.75,
                        ease: "linear",
                    },
                    "<"
                )
                .to(
                    ".upside.two",
                    {
                        height: "calc(50% + 115px)",
                        duration: 0.75,
                        ease: "linear",
                    },
                    "<"
                )
                .to(
                    ".upside.three",
                    {
                        height: "calc(50% + 90px)",
                        duration: 0.75,
                        ease: "linear",
                    },
                    "<"
                )

                .to(".line.one", {
                    width: "50%",
                    duration: 0.75,
                    ease: "linear",
                })
                .to(
                    ".line.two",
                    {
                        width: "50%",
                        duration: 0.75,
                        ease: "linear",
                    },
                    "<"
                )
                .to(
                    ".line.three",
                    {
                        width: "50%",
                        duration: 0.75,
                        ease: "linear",
                    },
                    "<"
                )
                .to(
                    ".upside.one",
                    {
                        width: "50%",
                        duration: 0.75,
                        ease: "linear",
                    },
                    "<"
                )
                .to(
                    ".upside.two",
                    {
                        width: "50%",
                        duration: 0.75,
                        ease: "linear",
                    },
                    "<"
                )
                .to(
                    ".upside.three",
                    {
                        width: "50%",
                        duration: 0.75,
                        ease: "linear",
                    },
                    "<"
                )

                .to(
                    ".line.one",
                    {
                        height: "calc(280px)",
                        bottom: "calc(50% - 165px)", // Moves it up while shrinking
                        duration: 0.75,
                        ease: "linear",
                    },
                    "<"
                )
                .to(
                    ".line.two",
                    {
                        height: "calc(280px)",
                        bottom: "calc(50% - 140px)", // Moves it up while shrinking
                        duration: 0.75,
                        ease: "linear",
                    },
                    "<"
                )
                .to(
                    ".line.three",
                    {
                        height: "calc(280px)",
                        bottom: "calc(50% - 115px)",
                        duration: 0.75,
                        ease: "linear",
                    },
                    "<"
                )
                .to(
                    ".upside.one",
                    {
                        height: "calc(280px)",
                        top: "calc(50% - 115px)", // Moves it up while shrinking
                        duration: 0.75,
                        ease: "linear",
                    },
                    "<"
                )
                .to(
                    ".upside.two",
                    {
                        height: "calc(280px )",
                        top: "calc(50% - 140px)",
                        duration: 0.75,
                        ease: "linear",
                    },
                    "<"
                )
                .to(
                    ".upside.three",
                    {
                        height: "calc(280px )",
                        top: "calc(50% - 165px)",
                        duration: 0.75,
                        ease: "linear",
                    },
                    "<"
                )
                .fromTo(
                    ".bottom-border",
                    {
                        opacity: 0,
                    },
                    {
                        opacity: 1,
                    }
                )
                .to(".line.two", {
                    opacity: 0,
                    duration: 0.75,
                })
                .to(
                    ".upside.two",
                    {
                        opacity: 0,
                        duration: 0.75,
                    },
                    "<"
                )
                .to(
                    ".upside.three",
                    {
                        width: "1",

                        duration: 0.75,
                        ease: "linear",
                    },
                    "<"
                )
                .to(
                    ".line.one",
                    {
                        duration: 0.75,
                        width: "0",
                        ease: "linear",
                    },
                    "<"
                )
                .to(".line.one", {
                    duration: 0.75,
                    height: "0",
                    ease: "linear",
                })

                .to(
                    ".upside.three",
                    {
                        height: "0",

                        duration: 0.75,
                        ease: "linear",
                    },
                    "<"
                )
                .to(
                    ".inclusive",
                    {
                        opacity: 0,
                        duration: 0.75,
                    },
                    "<"
                )
                .to(".line.three", {
                    duration: 0.75,
                    ease: "linear",
                    width: "38px",
                })
                .to(
                    ".upside.one",
                    {
                        right: "calc(50% - 119px)",
                        height: "256px",
                        duration: 0.75,
                        width: "25px",
                        ease: "linear",
                    },
                    "<"
                )
                .fromTo(
                    ".line.three",
                    {
                        left: `${startLeftPx}px`,
                    },
                    {
                        height: "256px",
                        left: `${endLeftPx}px`,
                        duration: 0.75,
                        ease: "linear",
                        width: "46px",
                    },
                    "<"
                )
                .to(
                    ".line.three",
                    {
                        bottom: "calc(50% - 127px)",
                        duration: 0.75,
                    },
                    "<"
                )
                .to(
                    ".upside.one",
                    {
                        top: "calc(50% - 129px)",
                        duration: 0.75,
                    },
                    "<"
                )

                .fromTo(
                    ".logo-no-color",
                    {
                        opacity: 0,
                    },
                    {
                        opacity: 1,
                        duration: 1,
                        delay: 0.5,
                    }
                )

                .to(".logo-no-color", {
                    opacity: 0,
                })
                .fromTo(
                    ".logo-color",
                    {
                        opacity: 0,
                    },
                    {
                        opacity: 1,
                        duration: 1,
                    },
                    "<"
                )
                .to(
                    ".line",
                    {
                        opacity: 0,
                    },
                    "<"
                )
                .to(
                    ".upside",
                    {
                        opacity: 0,
                    },
                    "<"
                );

            tl2.fromTo(
                ".border",
                { width: "0" },
                { width: "40%", duration: 0.75, ease: "power1.out" }
            )
                .fromTo(
                    ".border",
                    { height: 0 },
                    { height: "100%", ease: "linear", duration: 0.25 }
                )
                .fromTo(
                    ".section-one > *",
                    { opacity: 0 },
                    { opacity: 1, duration: 1, ease: "power1.out" }
                )
                .fromTo(
                    ".section-two > *",
                    { opacity: 0 },
                    { opacity: 1, duration: 1, ease: "power1.out" },
                    "<"
                )
                .fromTo(
                    ".section-three > *",
                    { opacity: 0 },
                    { opacity: 1, duration: 1, ease: "power1.out" },
                    "<"
                );

            ScrollTrigger.create({
                animation: tl2,
                trigger: ".home-three",
                start: "top bottom-=100",
                end: "top center-=100",
                scrub: true,
            });
        });
        return () => ctx.revert();
    }, [isMobile]);

    return (
        <>
            <div ref={containerRef} className="home-one">
                <div className="mayfair">
                    <h1 className="inclusive">
                        Inclusively {!isMobile && <>&nbsp;</>}
                        <br />
                        mayfair
                    </h1>
                    <div className="line one"></div>
                    <div className="line two"></div>
                    <div className="line three">
                        <div className="bottom-border"></div>
                    </div>
                    <div className="upside one">
                        <div className="bottom-border"></div>
                    </div>
                    <div className="upside two"></div>
                    <div className="upside three"></div>
                </div>
                <div className="logo">
                    <img className="logo-no-color" src="../images/logo.png" />
                    <img className="logo-color" src="../images/logo-dark.png" />
                </div>
            </div>
            <div className="home-two">
                <Gallery
                    images={[
                        "../images/gallery/1.jpg",
                        "../images/gallery/1a.jpg",
                        "../images/gallery/2.jpg",
                        "../images/gallery/3.jpg",
                        "../images/gallery/4.jpg",
                        "../images/gallery/5.jpg",
                        "../images/gallery/7.jpg",
                    ]}
                />
            </div>
            <div className="border-space">
                <div className="border"></div>
            </div>
            <div className="home-three">
                <div className="content-wrapper">
                    <div className="section-one">
                        <h1>
                            22,836 sq ft of
                            <br />
                            contemporary, fully
                            <br />
                            fitted, plug-and-play <br />
                            office space available
                        </h1>
                        <p>
                            Enjoy the benefits of a Mayfair location that
                            borders both Marylebone and Hyde Park.
                            <br />
                            <br />
                            The second and third floors at 64 North Row are
                            available on a flexible managed or traditional
                            lease.
                        </p>
                    </div>
                    <div className="section-two">
                        <div className="copy-wrapper">
                            <h2>second floor</h2>
                            <h5>11,455 sq ft / 1,064 sq m</h5>
                            <h5>122 DESKS</h5>
                        </div>
                        <p className="location">
                            Mayfair <br />
                            London W1K 7JA
                        </p>
                    </div>
                    <div className="section-three">
                        <div className="copy-wrapper">
                            <h2>third floor</h2>
                            <h5>11,381 sq ft / 1,057 sq m</h5>
                            <h5>140 DESKS</h5>
                        </div>
                        <a href="dl/brochure.pdf" target="_blank">
                            <p className="location brochure">
                                DOWNLOAD BROCHURE
                            </p>
                        </a>
                    </div>
                </div>
            </div>
            <div className="home-four">
                <div
                    style={{ backgroundImage: "url('../images/pattern.png')" }}
                    className="section-one"
                ></div>
                <div className="section-two">
                    <div className="agents">
                        <img src="../images/bluebook.svg" />
                        <div className="agent-wrapper">
                            <div className="agent">
                                <p className="name">Chris Watkin</p>
                                <a href="mailto:chris@bluebooklondon.co.uk">
                                    <p>Email</p>
                                </a>
                                <a href="tel:07730066523">
                                    <p>07730 066 523</p>
                                </a>
                            </div>
                            <div className="agent">
                                <p className="name">Tor Cuming</p>
                                <a href="mailto:tor@bluebooklondon.co.uk">
                                    <p>Email</p>
                                </a>
                                <a href="tel:07714089823">
                                    <p>07714 089 823</p>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section-three">
                    <div className="agents">
                        <img src="../images/newmark.svg" />
                        <div className="agent-wrapper">
                            <div className="agent">
                                <p className="name">Rhodri Phillips</p>
                                <a href="mailto:Rhodri.Phillips@nmrk.com">
                                    <p>Email</p>
                                </a>
                                <a href="tel:07768615296">
                                    <p>07768 615 296</p>
                                </a>
                            </div>
                            <div className="agent">
                                <p className="name">Milly Mitchell</p>
                                <a href="mailto:milly.mitchell@nmrk.com">
                                    <p>Email</p>
                                </a>
                                <a href="tel:07880477227">
                                    <p>07880 477 227</p>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="home-five">
                <p className="border">© Copyright 64 North Row. 2025.</p>
                <p>Disclaimer</p>
            </div>
        </>
    );
};

export default Home;
